import  { useEffect, useRef} from "react";
import { IoIosAdd, IoIosRemove } from "react-icons/io";
import { MdRestartAlt } from "react-icons/md";
import CircularProgress from "./ui/CircularProgress";
import nearReserve from "../../../assets/audios/reserve-not-met.mp3";
import pureSale from "../../../assets/audios/pure-sale.mp3";



const BidInput = ({
  car,
  timeLeft,
  isBonusTime,
  manualBid,
  setManualBid,
  currentBid,
  handleReset,
  activeBid,
  resetTimer,
  setResetTimer,
  bonusTime,
  setBonusTime,
  pusherStatus
}) => {

  const nearReserveSound = useRef(new Audio(nearReserve));
  const pureSaleSound = useRef(new Audio(pureSale));


  // Initialize previous state
  const prevBidState = useRef({
    wasNearReserve: false,
    wasReserveMet: false
  });



  useEffect(() => {
    if (!activeBid) return;

    const isReserveMet = !car?.minPrice || activeBid >= car?.minPrice;
    const isNearReserve = car?.minPrice && 
      (car.minPrice - activeBid <= 100 && car.minPrice - activeBid > 0);

    const playSound = async (audioRef) => {
      try {
        audioRef.current.currentTime = 0; // Reset audio position
        await audioRef.current.play();
      } catch (error) {
      }
    };

    // Play near reserve sound only when first entering near reserve state
    if (isNearReserve && !prevBidState.current.wasNearReserve) {
      playSound(nearReserveSound);
    }

    // Play pure sale sound only when first meeting reserve or when there's no minPrice
    if (isReserveMet && !prevBidState.current.wasReserveMet) {
      playSound(pureSaleSound);
    }

    // Update previous state
    prevBidState.current = {
      wasNearReserve: isNearReserve,
      wasReserveMet: isReserveMet
    };
  }, [activeBid, car?.minPrice]);

  const getBidStatus = () => {
    if (!activeBid) return null;
    
    const isReserveMet = !car?.minPrice || activeBid >= car?.minPrice;
    const priceDifference = car?.minPrice ? car.minPrice - activeBid : 0;
    const baseStyles = "font-bold text-xl uppercase animate-pulse border-2 px-3 py-1 rounded-md";
    const strokeTextStyle = {
      WebkitTextStroke: '1px currentColor',
      WebkitTextFillColor: 'transparent',
    };
  
    if (isReserveMet) {
      return (
        <span 
          className={`${baseStyles} border-green-500 text-green-500`}
          style={strokeTextStyle}
        >
          Pure Sale
        </span>
      );
    } else if (priceDifference <= 100 && priceDifference > 0) {
      return (
        <span 
          className={`${baseStyles} border-yellow-500 text-yellow-500`}
          style={strokeTextStyle}
        >
          Near Reserve
        </span>
      );
    } else {
      return (
        <span 
          className={`${baseStyles} border-red-500 text-red-500`}
          style={strokeTextStyle}
        >
          On Reserve
        </span>
      );
    }
  };
  

  return ( 
    <>  
      <div className="mb-[0.625vw] w-[150px] lg:w-[100%] flex flex-col items-center justify-between">
        <div className="w-full flex justify-between items-center">
          {getBidStatus()}
        
        </div>
        
        {/* add space */}
        <br />
        <div className="lg:h-full lg:w-full flex justify-center items-center">
          <CircularProgress 
            pusherStatus={pusherStatus} 
            resetTimer={resetTimer} 
            setResetTimer={setResetTimer} 
            bonusTime={bonusTime} 
            setBonusTime={setBonusTime} 
            currentBid={currentBid} 
            activeBid={activeBid}
            timeLeft={timeLeft}
            isBonusTime={isBonusTime}
          />
        </div>

        <div className="flex my-[0.625vw] w-full">
          <div className="relative flex items-center justify-center w-full">
            <input
              value={manualBid || currentBid}
              onChange={(e) => setManualBid(Number(e.target.value))}
              className="w-[70px] lg:max-w-[6.215vw] border text-[14px] lg:text-16 border-gray-300 rounded-sm lg:rounded-[0.625vw] px-1 py-1 lg:py-[0.417vw] text-center"
            />  
          </div>
          <span
              onClick={() => {
                handleReset();
              }}
              className="cursor-pointer  flex justify-center items-center text-gray-500 hover:text-gray-700"
            >
              <MdRestartAlt className="lg:text-20 md:text-[1.25vw]" />
            </span>
          <div className="flex items-center gap-1">
            <span
              onClick={() => {
                const latest = activeBid || currentBid || 0;
                setManualBid((prev) => {
                  const current = Number.isFinite(prev) ? prev : latest;
                  const decremented = current - 100;
                  const minAllowed = Math.max(0, latest);
                  return Math.max(minAllowed, decremented);
                });
              }}
              className="lg:text-20 text-red-600 rounded-[0.417vw] border border-red-600 p-[0.317vw] cursor-pointer hover:bg-red-600/10"
            >
              <IoIosRemove />
            </span>
            <span
              onClick={() => setManualBid((prev) => prev + 100)}
              className="lg:text-20 text-red-600 rounded-[0.417vw] border border-red-600 p-[0.317vw] cursor-pointer hover:bg-red-600/10"
            >
              <IoIosAdd />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default BidInput;
